<p>model-detail-history-view works!</p>
